import { useContext, useState } from 'react';
import { useMutation } from 'react-query';
import { useHistory, useLocation } from 'react-router-dom';

import { AuthApi } from '../../api/client';
import { DRAWER_TABS, ROUTES } from '../../constants';
import { authContext } from '../../contexts';
import { LoginData } from '../../models';
import View from './View';

type LocationState = {
  email: string | undefined;
};

const Container: React.FC = () => {
  const { onLogin } = useContext(authContext);
  const { state } = useLocation<LocationState>();
  const history = useHistory();
  const [loginError, setLoginError] = useState(false);

  const handleRedirect = () => {
    history.push(`${ROUTES.ADMIN_PANEL}/${DRAWER_TABS.PATIENTS}`);
  };

  const login = useMutation((data: LoginData) => AuthApi.login(data), {
    onSuccess: (res) => {
      const { token, refreshToken } = res.data;
      onLogin(token, refreshToken);
      handleRedirect();
    },
    onError: (err) => {
      console.log(err);
      setLoginError(true);
    },
  });

  const handleLogin = (email: string, password: string) => {
    const data = { email, password };
    setLoginError(false);
    login.mutate(data);
  };

  const requestDynamicLink = () => {
    history.push(ROUTES.REQUEST_DYNAMIC_LINK);
  };

  return (
    <View
      isLoading={login.isLoading}
      email={state?.email || ''}
      handleLogin={handleLogin}
      requestDynamicLink={requestDynamicLink}
      loginError={loginError}
    />
  );
};

export default Container;
